import { Scale, Stethoscope, Smile, Brain, Dumbbell, CalendarClock } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const niches = [
    {
        icon: Scale,
        title: "Advogados e escritórios",
        pain: "Clientes ligam em horário de audiência. O agente atende.",
    },
    {
        icon: Stethoscope,
        title: "Médicos e clínicas",
        pain: "Agenda lotada, mas 20% dos pacientes não aparecem. O agente lembra e confirma.",
    },
    {
        icon: Smile,
        title: "Dentistas",
        pain: "Paciente some depois do orçamento. O agente faz o follow-up.",
    },
    {
        icon: Brain,
        title: "Psicólogos e terapeutas",
        pain: "Sessão cancelada em cima da hora. O agente remarca automaticamente.",
    },
    {
        icon: Dumbbell,
        title: "Nutricionistas e personal trainers",
        pain: "Cliente esquece do horário. O agente avisa antes.",
    },
    {
        icon: CalendarClock,
        title: "Demais profissionais com agenda",
        pain: "Se você agenda, eu automatizo.",
    },
];

export const Niches = () => {
    return (
        <section id="nichos" className="relative py-24 md:py-32 lg:py-40">
            <div className="absolute inset-0 dg-grid opacity-20" />
            <div className="relative max-w-6xl mx-auto px-6 md:px-12">
                <Reveal>
                    <p className="text-sm md:text-base font-semibold uppercase tracking-widest text-[#94B4FF]">
                        Para quem é
                    </p>
                    <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#F5F5F5] max-w-3xl">
                        Para quem é a Degasperin IA
                    </h2>
                </Reveal>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                    {niches.map((n, i) => (
                        <Reveal key={n.title} delay={(i % 3) * 0.1}>
                            <div
                                data-testid={`niche-card-${i}`}
                                className="group h-full rounded-2xl border border-[#1E1E28] bg-[#121218] p-7 transition-all hover:border-[#3B6FFF]/40 hover:-translate-y-1"
                            >
                                <div className="inline-flex items-center justify-center rounded-xl border border-[#1E1E28] bg-[#0A0A0F] p-3 text-[#3B6FFF] transition-colors group-hover:bg-[#3B6FFF] group-hover:text-white">
                                    <n.icon className="w-6 h-6" />
                                </div>
                                <h3 className="mt-5 font-display text-lg font-semibold text-[#F5F5F5]">
                                    {n.title}
                                </h3>
                                <p className="mt-2 text-[#F5F5F5]/60 leading-relaxed">
                                    {n.pain}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Niches;
